module.exports = __webpack_public_path__ + "img/banner_healthy.1702e1a7.png";